import { FC } from "react";
import classNames from "classnames";
import { Form, Formik } from "formik";

import { AddFormProps } from "./types";
import Button from "../Button/Button";
import { FormikInputFieldLight } from "../FormikField";

import styles from "./AddForm.module.css";



const AddForm: FC<AddFormProps> = ({
  value,
  onChange,
  onAddItem,
  placeholder,
  onFocus,
}) => {
  const handleOnSubmit = () => {
    onAddItem(value);
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{ searchValue: value.label }}
      onSubmit={handleOnSubmit}
    >
      {({ values }) => (
        <Form className={classNames(styles.form)}>
          <div className={classNames(styles.form__content)}>
            <FormikInputFieldLight
              onFocus={onFocus}
              autoComplete="off"
              required
              name="searchValue"
              value={values.searchValue}
              placeholder={placeholder}
              onInput={onChange}
            />
          </div>
          <div className={styles.form__actions}>
            {values.searchValue && <Button type="submit" label="Confirm" />}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddForm;
